import { render } from "./SurplusBars.vue?vue&type=template&id=3a70bf00&scoped=true"
import script from "./SurplusBars.vue?vue&type=script&lang=js"
export * from "./SurplusBars.vue?vue&type=script&lang=js"

import "./SurplusBars.vue?vue&type=style&index=0&id=3a70bf00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a70bf00"]])

export default __exports__